// extracted by mini-css-extract-plugin
export var input = "checkbox-module--input--61910";